<template>
  <div class="layout-row comment-but f-c">
    <span class="font-12-999" style="color: #fe7d37" @click="set(0)"
      >{{ item.is_digg == 1 ? "已" : "" }}赞({{ item.digg_count }})</span
    >
    <span v-if="is_oppos()" class="font-12-999" @click="set(1)"
      >{{ item.is_oppos == 1 ? "已" : "" }}踩({{ item.oppos_num }})</span
    >
    <span v-if="is_coll()" class="font-12-999" @click="set(2)"
      >{{ item.is_coll == 1 ? "已" : "" }}收藏({{ item.coll_num }})</span
    >
    <span
      class="font-12-333"
      :class="{ reply: item.reply_num > 0 }"
      @click="replyTap(item)"
      >{{ set4Text }}({{ item.reply_num }})</span
    >
  </div>
</template>

<script>
export default {
  props: ["data", "item", "info"],
  data() {
    return {
      set4Text: "回复",
    };
  },
  created() {
    if (this.$route.name == "Reply") {
      this.set4Text = "评论";
    }
  },
  methods: {
    is_oppos() {
      if (this.$route.query.is_message == 1) {
        return false;
      }
      return true;
    },
    is_coll() {
      if (this.$route.query.source == 2) {
        return false;
      }
      if (this.$route.query.is_lecture == 1) {
        return false;
      }
      if (this.$route.query.is_tidan == 1) {
        return false;
      }
      if (this.$route.query.is_message == 1) {
        return false;
      }
      if (this.$route.query.is_sheetExam == 1) {
        return false;
      }

      return true;
    },
    set(type) {
      if (type == 0) {
        if (this.item.is_digg == 1) {
          this.item.is_digg = 0;
          this.item.digg_count--;
        } else {
          this.item.is_digg = 1;
          this.item.digg_count++;
        }
        let url = "";
        if (this.$route.query.source == 1) {
          url = "/comment/digg";
        } else {
          url = "/sheet/digg";
          if (this.$route.query.is_tidan == 1) {
            url = "/sheet/cate_digg";
          }
        }

        if (this.$route.query.is_lecture == 1) {
          url = "/tiku/lecture/comment_digg";
        }

        this.$axios
          .post(url, {
            comment_id: this.item.comment_id,
            tab_key: this.item.tab_key,
            sheet_id: this.$route.query.sheet_id,
            sheet_type: this.$route.query.sheet_type,
            lecture_id: this.$route.query.lecture_id,
          })
          .then((res) => {});
      }
      if (type == 1) {
        if (this.item.is_oppos == 1) {
          this.item.is_oppos = 0;
          this.item.oppos_num--;
        } else {
          this.item.is_oppos = 1;
          this.item.oppos_num++;
        }
        let url = "";
        if (this.$route.query.source == 1) {
          url = "/comment/oppos";
        } else {
          url = "/sheet/oppos";
          if (this.$route.query.is_tidan == 1) {
            url = "/sheet/cate_oppos";
          }
        }
        if (this.$route.query.is_lecture == 1) {
          url = "/tiku/lecture/comment_oppos";
        }

        this.$axios
          .post(url, {
            comment_id: this.item.comment_id,
            tab_key: this.item.tab_key,
            sheet_id: this.$route.query.sheet_id,
            sheet_type: this.$route.query.sheet_type,
            lecture_id: this.$route.query.lecture_id,
          })
          .then((res) => {});
      }
      if (type == 2) {
        if (this.item.is_coll == 1) {
          this.item.is_coll = 0;
          this.item.coll_num--;
        } else {
          this.item.is_coll = 1;
          this.item.coll_num++;
        }

        let url = "";
        if (this.$route.query.source == 1) {
          url = "/comment/coll";
        } else {
          url = "/sheet/coll";
          if (this.$route.query.is_tidan == 1) {
            url = "/sheet/cate_coll";
          }
        }
        this.$axios
          .post(url, {
            question_id: this.item.question_id,
            comment_id: this.item.comment_id,
            tab_key: this.item.tab_key,
            sheet_id: this.$route.query.sheet_id,
            sheet_type: this.$route.query.sheet_type,
          })
          .then((res) => {});
      }
    },
    replyTap(item) {
      if (item.reply_num > 0) {
        if (item.comment_id == this.$route.query.comment_id) {
          return;
        }
        let data = this.$route.query;
        data.question_id = item.question_id;
        data.comment_id = item.comment_id;
        data.tab_key = item.tab_key;
        this.$router.push({
          path: `/h5/comment/Reply/${item.comment_id}`,
          query: data,
        });
      } else {
        this.$store.commit("setCommentSetShow", {
          show: true,
          update: 0,
          data: this.item,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.comment-but {
  justify-content: flex-end;
  padding-top: 1rem;
  span {
    margin-left: 0.75rem;
    font-size: 0.55rem;
  }
  .reply {
    padding: 0.1rem 0.3rem;
    background: #f0f0f0;
    border-radius: 0.45rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/page/comment/set.vue